module.exports = __webpack_public_path__ + "img/guide1-4.1cfd3f10.png";